import { createContext } from "react";

type HeaderContentContextType = {
	openSearch?: boolean;
	setOpenSearch?: React.Dispatch<React.SetStateAction<boolean>>;
};

const HeaderSearchContext = createContext<HeaderContentContextType>({});

export default HeaderSearchContext;
